import { supabase } from '@app-studio-web/ui/helpers/supabase'

export const createCredits = async () => {
  try {
    const { error } = await supabase.functions.invoke(
      'run-fusion-create-credits-row',
    )
    // console.log('data', data);

    if (error) {
      console.error('❌ Edge Function error details:', {
        message: error.message,
        status: error.status,
        name: error.name,
        details: error.details,
      })

      // Don't throw error for now, just log it
      // This allows onboarding to continue even if credits creation fails
      console.warn(
        '⚠️ Credits row creation failed, but continuing with onboarding',
      )
      return { success: false }
    }

    // return data?.message; // "Credits row created or already exists"
    return { success: true }
  } catch (err) {
    console.error('💥 Unexpected error in createCreditsRowForUser:', err)
    // Don't throw error, just log it and continue
    console.warn(
      '⚠️ Credits row creation failed, but continuing with onboarding',
    )
    return { success: false }
  }
}
